export default __webpack_public_path__ + "media/ed84687e622657209e04985cf26abafae0de640d817abd6a8d42742460443404.svg";